if (typeof $("input.grab-donation") !== "undefined") {
  $("input.grab-donation").wrap(
    '<div class="donation-custom" style="display:none"></div>'
  );

  $('input[name="wc_donation_gift_aid_checkbox"]').prop("checked", true);
}

$('.wc-donation-in-action input[type="radio"]').on("click", function () {
  const val = $(this).val();

  if (val === "wc-donation-other-amount") {
    $(".donation-custom").show();
  }

  if (val !== "wc-donation-other-amount") {
    $(".donation-custom").hide();
  }
});

// move $('.wc_donation_on_cart .wc-donation-gift-aid-wrapper') to come after $('.in-action-elements') in the same area
$(".wc_donation_on_cart .wc-donation-gift-aid-wrapper").insertAfter(
  ".in-action-elements"
);

jQuery(document.body).on("removed_from_cart updated_cart_totals", function () {
  $(".wc_donation_on_cart .wc-donation-gift-aid-wrapper").insertAfter(
    ".in-action-elements"
  );

  checkDonation();
});

// foreach cart item if has class .cart-item-donation console.log('donation')
checkDonation();

function checkDonation() {
  $(
    ".cart .cart_item, .woocommerce-checkout-review-order-table .cart_item"
  ).each(function () {
    if ($(this).hasClass("cart-item-donation")) {
      $("head").append(
        "<style>.coupon, .woocommerce-form-coupon-toggle { display: none; }</style>"
      );
    } else {
      $("head").append(
        "<style>.coupon, .woocommerce-form-coupon-toggle { display: block; }</style>"
      );
    }
  });
}
